import withGoogleAnalytics from './withGoogleAnalytics'

export default withGoogleAnalytics
